import Vue from 'vue';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

class GoogleMapsServiceClient {
  private readonly instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: 'https://maps.googleapis.com/maps/api',
      params: {
        key: Vue.prototype.$tenant?.googleMapsApiKey
      }
    });
  }

  get<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.instance.get<T>(url, config);
  }

  post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.instance.post<T>(url, data, config);
  }

  put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.instance.put<T>(url, data, config);
  }

  delete<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this.instance.delete<T>(url, config);
  }
}

export const googleMapsServiceClient = new GoogleMapsServiceClient();
